// ABOUTME: Resolves the label shown for an offer/cart line item from its persisted and linked data.
// ABOUTME: Mirrors the model-selection catalog order so a product reads the same name everywhere.

export interface LineItemNameParts {
    /** Name persisted on the line item (custom items and non-configurable models). */
    productName?: string;
    /** Commercial name carried by the prototype node itself. */
    prototypeName?: string;
    /** Commercial name of the model the prototype (or the line item) links to. */
    modelName?: string;
    prototypeCode?: string;
    modelCode?: string;
    /** Last resort when nothing else is available, e.g. `Item #3`. */
    fallback: string;
}

/**
 * First non-empty value of the display priority chain. The prototype/model name comes before the
 * codes so a line item shows the commercial name used in model selection and in the configurator,
 * with the codes kept as a fallback for nodes that carry no name.
 */
export function resolveLineItemName(parts: LineItemNameParts): string {
    return (
        parts.productName ||
        parts.prototypeName ||
        parts.modelName ||
        parts.prototypeCode ||
        parts.modelCode ||
        parts.fallback
    );
}
